import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import '@branding/theme.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/app.css';
import { AuthProvider, useAuth } from './lib/auth';
import { AppShell } from './components/AppShell';
import { LoginPage } from './pages/LoginPage';
import { StreamsPage } from './pages/StreamsPage';
import { MonitorPage } from './pages/MonitorPage';
import { UsersPage } from './pages/UsersPage';
import { AccountPage } from './pages/AccountPage';
import { StreamFormPage } from './pages/StreamFormPage';
import { ReportsPage } from './pages/ReportsPage';
import { PresetsPage } from './pages/PresetsPage';
import { PresetEditPage } from './pages/PresetEditPage';
import { AlertsPage } from './pages/AlertsPage';
import { SettingsPage } from './pages/SettingsPage';
import { socket } from './lib/socket';

function Root() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) {
    socket.stop();
    return <LoginPage />;
  }
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<StreamsPage />} />
        <Route path="streams/new" element={<StreamFormPage />} />
        <Route path="streams/:id" element={<MonitorPage />} />
        <Route path="streams/:id/edit" element={<StreamFormPage />} />
        <Route path="streams/:id/reports" element={<ReportsPage />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="presets" element={<PresetsPage />} />
        {user.role === 'admin' && <Route path="presets/:id" element={<PresetEditPage />} />}
        {user.role === 'admin' && <Route path="users" element={<UsersPage />} />}
        {user.role === 'admin' && <Route path="settings" element={<SettingsPage />} />}
        <Route path="account" element={<AccountPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
